const SCHEDULER_INITIALIZED_ATTRIBUTE = 'data-nudge-scheduler-initialized';
export const setNudgeSchedulerInitialized = () => {
  window.document.body.setAttribute(SCHEDULER_INITIALIZED_ATTRIBUTE, 'true');
};
export const clearNudgeSchedulerInitialized = () => {
  window.document.body.removeAttribute(SCHEDULER_INITIALIZED_ATTRIBUTE);
};
export const isNudgeSchedulerInitialized = () => {
  return window.document.body.getAttribute(SCHEDULER_INITIALIZED_ATTRIBUTE) === 'true';
};
export const waitForNudgeSchedulerInitialized = () => {
  return new Promise(resolve => {
    if (isNudgeSchedulerInitialized()) {
      resolve(true);
      return;
    }
    const observer = new MutationObserver(() => {
      if (isNudgeSchedulerInitialized()) {
        observer.disconnect();
        resolve(true);
      }
    });
    observer.observe(window.document.body, {
      attributes: true,
      attributeFilter: [SCHEDULER_INITIALIZED_ATTRIBUTE]
    });
  });
};